// skeleton/app/src/app/shared/components/QuestionTypes/QuesInputType-sign/inputType-sign.component.ts

import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import type { SimpleChanges } from '@angular/core';
import { SignaturePad } from 'angular2-signaturepad';
import { ButtonSize, ButtonStyle, ButtonType } from 'src/app/shared/components/inputs/button/button.model';
import { ModalSize } from 'src/app/shared/components/view/modal/modal.model';
import { Constants } from 'src/app/shared/constants';
import { KeyValue } from 'src/app/shared/models/keyvalue.model';
import { QuestionViewModel } from 'src/app/shared/models/questionview.model';
import { BaseHttpService } from 'src/app/shared/services/basehttp.service';
import { GlobalsessionhandlerService } from 'src/app/shared/services/globalsessionhandler.service';
import { NotificationService } from 'src/app/shared/services/notifications.service';

import { TokenStorageService } from 'src/app/shared/services/token-storage.service';

@Component({
  selector: 'app-inputType-sign',
  templateUrl: './inputType-sign.component.html',
  styleUrls: ['./inputType-sign.component.scss'],
  standalone: false
})
export class InputTypeSignComponent implements OnInit, OnChanges {
  hideSignPopUp = true;
  showImage = false;
  userLoginName: string = "";

  @Input() question: QuestionViewModel;
  @Input() questionIndex: number;
  @Input() totalQuestion: number;
  @Input() showName?: boolean = true;
  @Output() childQuestion: EventEmitter<QuestionViewModel> = new EventEmitter<QuestionViewModel>();
  @Output() inputChange: EventEmitter<Boolean> = new EventEmitter<Boolean>();
  @Input() IsReadOnly?: boolean = false;
  @Input() IsConsentScreen?: boolean = false;

  saveBtnText: string = 'OK';
  btnXlarge = ButtonSize.Medium;
  btnWithText = ButtonStyle.Textonly;
  btnRect = ButtonType.Rectangle;
  clearBtnText: string = "CLEAR"
  modalText = "Setup and sign";
  modalSize = ModalSize.CustomSignaturePopup;
  imageSrc: string = "";
  errormgvisible: boolean = false;
  validationerrormessage: string[] = [];
  errorMessages: string[] = [];
  IsSignDrawn: boolean = false;
  selectedUser: string = "";
  userSignRole: string = ""
  esignDate: string;
  OptionSelectedToDrawSign: boolean = true;
  UserNameAsText: string = "";
  private context: CanvasRenderingContext2D;
  nameFlag: boolean = false;
  constants: Constants = new Constants();
  showUserNameAsSign: boolean = false;
  errorMsg: String = ""
  userRoleDesc: string = ""
  prevSignInRole: string = ""
  userMailId: string = ""
  loggedInUserMailId: string = ""
  private hasRenderedInitialText: boolean = false;

  @ViewChild('canvasEl', { static: false, read: ElementRef }) canvasEl: ElementRef;

  isESignAllowed: boolean = false;
  isSSignAllowed: boolean = false;
  OptionSelectedToTypeSign: boolean = false;
  enteredName: string = "";
  enteredDate: string = "";
  validationErrors: string[] = [];

  @ViewChild(SignaturePad, { static: false }) signaturePad: SignaturePad;
  public signaturePadOptions: Object = {
    'minWidth': 2,
    'maxWidth': 4,
    'canvasWidth': 750,
    'canvasHeight': 200,
    'penColor': '#000000',
    'backgroundColor': 'rgba(255,255,255,0)'
  };

  constructor(
    private sessionHandleService: GlobalsessionhandlerService,
    private notificationService: NotificationService,
    private baseHttpService: BaseHttpService,

    private storage: TokenStorageService
  ) { }

  /**
   * Auto-fill user name from session/storage (only for RS provider type)
   */
  private autoFillUserName(): void {
    this.userLoginName = this.sessionHandleService.getLoggedInUserName().toUpperCase();
    let userName = this.sessionHandleService.getLoggedInUserName().split(",");
    this.selectedUser = userName[1].trim() + " " + userName[0].trim();
    this.UserNameAsText = userName[1].trim() + " " + userName[0].trim();
  }

  /**
   * Called when canvas element becomes available or changes
   */
  private onCanvasReady(): void {
    if (this.OptionSelectedToTypeSign && this.selectedUser?.length > 0) {
      this.signTextChange(this.selectedUser);
    }
  }

  drawSelect(e) {
    this.hasRenderedInitialText = e.checked == false ? false : true;
    this.OptionSelectedToDrawSign = e.checked;
    this.OptionSelectedToTypeSign = e.checked == true ? false : e.checked;
    this.signaturePad?.clear();
    this.IsSignDrawn = false;
    this.validationErrors = [];
  }

  textSelect(event) {
    this.OptionSelectedToDrawSign = false;
    this.clearSign();
    if (this.OptionSelectedToTypeSign) {
      this.signTextChange(this.selectedUser);
    }
  }

  onKeyPress(event) {
    this.selectedUser = event.target.value;
    this.UserNameAsText = event.target.value;
    (this.selectedUser.length > 0) ? this.nameFlag = false : this.nameFlag = true;
    this.signTextChange(this.selectedUser.trim());
    this.validationErrors = [];
  }

  resetSign() {
    if (!this.question.responseText?.length) {
      this.imageSrc = null;
      this.showImage = false;
    }
  }

  onInput(event) {
    if (event.target.value.trim() != "") {
      this.nameFlag = false
    }
  }

  signTextChange(selectedUser: string) {
    if (this.canvasEl?.nativeElement) {
      try {
        const canvas = this.canvasEl.nativeElement as HTMLCanvasElement;
        this.context = canvas.getContext('2d');
        if (this.context) {
          this.context.clearRect(0, 0, canvas.width, canvas.height);

          if (!selectedUser?.trim()) {
            return;
          }

          this.context.font = 'italic 24px "Segoe Script"';
          this.context.textAlign = 'center';
          this.context.textBaseline = 'middle';
          this.context.fillStyle = 'black';

          const formattedText = `/${selectedUser}/`;

          const textWidth = this.context.measureText(formattedText).width;
          const availableWidth = canvas.width - 40;

          if (textWidth > availableWidth) {
            const scaleFactor = availableWidth / textWidth;
            const fontSize = Math.floor(24 * scaleFactor);
            this.context.font = `italic ${fontSize}px "Segoe Script"`;
          }

          this.context.fillText(formattedText, canvas.width / 2, canvas.height / 2);
          console.log('Text signature rendered successfully:', selectedUser);
        }
      } catch (error) {
        console.warn('Canvas not ready for text rendering:', error);
      }
    } else {
      console.log(
        'Canvas element not ready, skipping text render. CanvasEl:',
        !!this.canvasEl,
        'CanvasElement:',
        !!this.canvasEl?.nativeElement,
        'SelectedUser:',
        selectedUser
      );
    }
  }

  drawComplete() {
    console.log('Drawing completed');
    this.validationErrors = [];
    this.IsSignDrawn = this.signaturePad && !this.signaturePad.isEmpty();
    if (this.IsSignDrawn) {
      this.nameFlag = false;
    }
  }

  drawStart() {
    this.IsSignDrawn = this.signaturePad && !this.signaturePad.isEmpty();
    if (this.IsSignDrawn) {
      this.nameFlag = false;
    }
  }

  getUserInfo() {
    this.baseHttpService.get(this.constants.getUser).subscribe(result => {
      if (result != null) {
        let loginname = result.fullName.split(",");
        this.storage.set("LoggedInuserFirstName", loginname[1].trim());
        this.sessionHandleService.setLoggedInUserName(loginname[1].trim() + ", " + loginname[0].trim());
        this.storage.set("UserGroupId", result.userGroupId);
        this.storage.set("LoggedInUserTypeDesc", result.userTypeDesc);
        this.storage.set("LoggedInuserMailId", result.email);

        this.loggedInUserMailId = result.email;
      }
    });
  }

  ngDoCheck() {
    this.errorMessages = []
    this.errormgvisible = false;
    this.validationErrors = [];

    if (this.question.errorMessage) {
      if (this.question.isQuestionRequired == "Y" && (this.question.responseText == null || this.question.responseText.length <= 0)) {
        this.errorMessages.push("Input is mandatory");
        this.errormgvisible = true;
        this.question["IsValid"] = false;
      }
    }

    this.resetSign();
  }

  ngOnInit() {
    this.userLoginName = this.sessionHandleService.getLoggedInUserName().toUpperCase();
    let userName = this.sessionHandleService.getLoggedInUserName().split(",");

    this.userRoleDesc = this.storage.get("LoggedInUserTypeDesc");
    this.loggedInUserMailId = this.storage.get("LoggedInuserMailId");

    if (userName.length <= 0 || userName[0].length == 0 || this.userRoleDesc == '' || this.loggedInUserMailId == '') {
      this.getUserInfo();
    }

    this.nameFlag = false;
    this.userLoginName = this.sessionHandleService.getLoggedInUserName().toUpperCase();

    let selectedSignTypes: string[] = this.question.questionSignTypes;
    if (selectedSignTypes && selectedSignTypes.length > 0) {
      this.isESignAllowed = selectedSignTypes.includes("esign");
      this.isSSignAllowed = selectedSignTypes.includes("ssign");
      this.OptionSelectedToDrawSign = this.isESignAllowed;
    }

    this.setQuestionResponseText();

    if (this.loggedInUserMailId != this.userMailId && this.userRoleDesc && this.userRoleDesc.toLowerCase() != 'group admin') {
      delete this.question["responseText"];
      this.question["IsValid"] = false;
      this.resetSign();
      this.userSignRole = ""
      this.userMailId = ""
      this.selectedUser = ""
    }

    this.CheckRequiredValidation();
    this.childQuestion.emit(this.question);
  }

  setQuestionResponseText() {
    this.showImage = false;
    this.imageSrc = null;

    if (this.question.responseText && this.question.responseText.length > 0) {
      let signDet = JSON.parse(this.question.responseText);
      const data = signDet["key"].split("||")
      this.selectedUser = data[0];
      this.userSignRole = data[1];
      this.userMailId = data[2];
      this.esignDate = data[3];
      this.imageSrc = signDet["value"] != null && signDet["value"].length > 0 ? signDet["value"] : null;
      this.showImage = this.imageSrc != null ? true : false;
    }
  }

  setEsignDate() {
    try {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const now = new Date();
      if (tz) {
        const parts = new Intl.DateTimeFormat('en-CA', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
        const byType = parts.reduce((acc, p) => { if (p.type !== 'literal') acc[p.type] = p.value; return acc; }, {} as any);
        this.esignDate = `${byType.year}-${byType.month}-${byType.day}`;
      } else {
        const localNow = new Date();
        const year = localNow.getFullYear();
        const month = String(localNow.getMonth() + 1).padStart(2, '0');
        const day = String(localNow.getDate()).padStart(2, '0');
        this.esignDate = `${year}-${month}-${day}`;
      }
    } catch (e) {
      const localNow = new Date();
      const year = localNow.getFullYear();
      const month = String(localNow.getMonth() + 1).padStart(2, '0');
      const day = String(localNow.getDate()).padStart(2, '0');
      this.esignDate = `${year}-${month}-${day}`;
    }
  }

  get formattedEsignDate(): string {
    if (!this.esignDate) return '';
    const [year, month, day] = this.esignDate.split('-');
    return `${month}/${day}/${year}`;
  }

  showSignataurePad() {
    this.hideSignPopUp = false;

    if (!this.selectedUser || this.selectedUser.trim().length === 0) {
      this.autoFillUserName();
    }

    if (!this.esignDate || this.esignDate === "") {
      this.setEsignDate();
    }

    this.IsSignDrawn = !!(this.signaturePad && !this.signaturePad.isEmpty());

    this.inputChange.emit(true);
  }

  clearAndSignAgain() {
    this.hideSignPopUp = false;
    this.OptionSelectedToDrawSign = true;
    this.OptionSelectedToTypeSign = false;

    this.autoFillUserName();
    if (!this.selectedUser) {
      this.selectedUser = "";
    }

    this.userSignRole = "";
    this.setEsignDate();
    this.signaturePad?.clear();
    this.IsSignDrawn = false;
    this.showUserNameAsSign = false;
  }

  close(event: any) {
    this.selectedUser = "";
    this.userSignRole = "";
    this.userMailId = "";
    this.esignDate = "";
    this.hideSignPopUp = true;
    this.setQuestionResponseText();
  }

  ok() {
    if (!this.validatePopupData()) {
      this.hideSignPopUp = false;
      return;
    }

    if (this.selectedUser.length > 0 && this.userSignRole.length > 0 && this.esignDate) {
      if (this.signaturePad != undefined && !this.signaturePad.isEmpty()) {
        this.imageSrc = this.signaturePad.toDataURL();
        this.showImage = true;
        let resp = new KeyValue();
        resp.key = this.selectedUser + "||" + this.userSignRole + "||" + this.loggedInUserMailId + "||" + this.esignDate
        resp.value = this.imageSrc;
        this.question["responseText"] = JSON.stringify(resp);
        this.OptionSelectedToDrawSign = true;
      }
      else if (this.canvasEl != undefined && this.selectedUser.length > 0) {

        let context1 = (this.canvasEl.nativeElement as HTMLCanvasElement);
        let resp = new KeyValue();
        resp.key = this.selectedUser + "||" + this.userSignRole + "||" + this.loggedInUserMailId + "||" + this.esignDate
        resp.value = context1.toDataURL('image/png', 4);
        this.question["responseText"] = JSON.stringify(resp);
        this.imageSrc = context1.toDataURL('image/png', 4);
        this.showImage = true;
        this.OptionSelectedToDrawSign = false;
        this.OptionSelectedToTypeSign = true;

      }
      else {
        this.imageSrc = "";
        if (!this.IsSignDrawn) {
          this.nameFlag = true;
          this.clearSign();
        }
      }

      this.hideSignPopUp = true;
    }

    this.CheckRequiredValidation();
    this.childQuestion.emit(this.question);
  }

  clearSign() {
    this.IsSignDrawn = false;

    if (this.signaturePad != undefined) {
      this.signaturePad.clear();
      this.IsSignDrawn = false;
    }
  }

  CheckRequiredValidation() {
    if (this.question.isQuestionRequired == 'Y' &&
      ((this.signaturePad != undefined && this.signaturePad.isEmpty()) &&
        (this.selectedUser == null || this.selectedUser.trim().length === 0))) {
      this.errorMessages.push("Input is mandatory");
      this.errormgvisible = true;
      this.question["IsValid"] = false;
    }
    else {
      this.errormgvisible = false;
      this.question["IsValid"] = true;
    }
    this.childQuestion.emit(this.question);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['question'] && changes['question'].currentValue) {
      const currentQuestion = changes['question'].currentValue;
      this.question = { ...currentQuestion };
      if (this.question.responseText && this.question.responseText.length > 0) {
        let signDet = JSON.parse(this.question.responseText);
        const data = signDet["key"].split("||")
        this.UserNameAsText = data[0];
        this.userSignRole = data[1];
        this.userMailId = data[2];
        this.esignDate = data[3];
        this.imageSrc = signDet["value"];
        this.showImage = true;
        this.childQuestion.emit(this.question);
      }
      else {
        this.imageSrc = null;
        this.showImage = false;
      }

      this.CheckRequiredValidation();
      this.childQuestion.emit(this.question);
    }
  }

  validatePopupData(): boolean {
    this.validationErrors = [];

    if (this.selectedUser == null || this.selectedUser.length == 0) {
      this.validationErrors.push("Signature name is mandatory");
    }
    if (this.userSignRole == null || this.userSignRole.length == 0) {
      this.validationErrors.push("Role is mandatory");
    }
    if (this.esignDate == null || this.esignDate.length == 0) {
      this.validationErrors.push("Signature date is mandatory");
    }

    if (this.OptionSelectedToDrawSign) {
      if (this.signaturePad == null || (this.signaturePad != null && this.signaturePad.isEmpty())) {
        this.validationErrors.push("Please draw signature");
      }
    }

    if (this.OptionSelectedToTypeSign) {
      if (this.selectedUser == null || (this.selectedUser != null && this.selectedUser.trim().length == 0)) {
        this.validationErrors.push("Please enter name for /s/ signature");
      }
    }

    return this.validationErrors.length === 0;
  }

  ngAfterViewChecked() {
    if (this.OptionSelectedToTypeSign &&
      this.selectedUser?.length > 0 &&
      this.canvasEl?.nativeElement &&
      !this.hasRenderedInitialText) {

      this.signTextChange(this.selectedUser);
      this.hasRenderedInitialText = true;
    }
  }

  ngAfterViewInit() {
    if (this.signaturePad) {
      this.signaturePad.clear();
      this.signaturePad.set('minWidth', 1);
      this.signaturePad.set('maxWidth', 2);
      this.signaturePad.set('backgroundColor', 'rgb(255, 255, 255)');
      this.signaturePad.set('penColor', 'rgb(0, 0, 0)');
    }

    this.onCanvasReady();
  }
}
